export default {
  namespaced: true,
  state: {
    hasUserClosedSlideOut: false,
    isSlideOutVisible: false,
    sidebarCloseTimeout: null
  },

  mutations: {
    CLOSE_SLIDEOUT (state) {
      state.isSlideOutVisible = false
      state.hasUserClosedSlideOut = true
    },

    OPEN_SLIDEOUT (state) {
      state.isSlideOutVisible = true
      state.hasUserClosedSlideOut = false
    },

    SET_SIDEBAR_CLOSE_TIMEOUT (state, timeout) {
      state.sidebarCloseTimeout = timeout
    },

    CLEAR_SIDEBAR_CLOSE_TIMEOUT (state) {
      clearTimeout(state.sidebarCloseTimeout)
    }
  },

  getters: {
    activeSidebar (state, getters, rootState, rootGetters) {
      const routeName = rootState.route.name
      const pathway = rootState.route.params.pathway

      if (routeName === 'page' && rootGetters.activePage) {
        return {
          description: rootGetters.activePage.description[rootState.language.code] || rootGetters.activePage.description['en'],
          filterType: '',
          heading: rootGetters.activePage.heading[rootState.language.code] || rootGetters.activePage.heading['en'],
          markerGuide: false,
          minimapImage: rootGetters.activePage.minimapImage,
          qrMessage: rootGetters.activePage.qrMessage,
          qrUrl: rootGetters.activePage.qrUrl,
          virtualTourUrl: rootGetters.activePage.virtualTourUrl,
          virtualTourButtonLabel: rootGetters.activePage.virtualTourButtonLabel,
          issuuEmbedUrl: rootGetters.activePage.issuuEmbedUrl,
        }
      }

      if (['live'].includes(routeName) && rootGetters.config) {        
        return {
          description: rootGetters.config.liveHereDescription[rootState.language.code] || rootGetters.config.liveHereDescription['en'],
          filterType: pathway,
          heading: rootGetters.config.liveHereHeading[rootState.language.code] || rootGetters.config.liveHereHeading['en'],
          markerGuide: false,
          minimapImage: rootGetters.config.liveHereSidebarMinimap,
          qrMessage: '',
          qrUrl: '',
          isFilterHidden: rootGetters['property/activeLivingOption'] ? rootGetters['property/activeLivingOption'].isFilterHidden : false,
        }
      }

      if (['living-entry'].includes(routeName) && rootGetters.config) {      
        return {
          description: rootGetters.config.liveHereDescription[rootState.language.code] || rootGetters.config.liveHereDescription['en'],
          filterType: '',
          heading: rootGetters.config.liveHereHeading[rootState.language.code] || rootGetters.config.liveHereHeading['en'],
          markerGuide: false,
          minimapImage: rootGetters.config.liveHereSidebarMinimap,
          qrMessage: '',
          qrUrl: '',
        }
      }

      if (['living-option'].includes(routeName) && rootGetters['property/activeLivingOption']) {
        const livingOption = rootGetters['property/activeLivingOption']
        return {
          description: livingOption.description[rootState.language.code] || livingOption.description['en'],
          heading: livingOption.displayName[rootState.language.code] || livingOption.displayName['en'] || livingOption.label,
          minimapImage: livingOption.sidebarMinimap,
          qrMessage: '',
          qrUrl: '',
          isFilterHidden: livingOption.isFilterHidden,
        }
      }     

      if (['subsection', 'property'].includes(routeName) && rootGetters['property/activeSubsection']) {      
        const livingOption = rootGetters['property/activeLivingOption']
        const subsection = rootGetters['property/activeSubsection']
        const parentSubsection = subsection.parent.type === 'subsection' ? rootGetters['property/subsections'].find(_subsection => subsection.parent.id === _subsection._id) : null
        return {
          description: subsection.description[rootState.language.code] || subsection.description['en'],
          filterType: pathway,
          heading: parentSubsection ? parentSubsection.displayName[rootState.language.code] ||  parentSubsection.displayName['en'] : livingOption.displayName[rootState.language.code] || livingOption.displayName['en'],
          markerGuide: subsection.properties.length ? true : false,
          minimapImage: subsection.minimapImage || livingOption.sidebarMinimap,
          qrMessage: '',
          qrUrl: '',
          isFilterHidden: subsection.isFilterHidden,
        }
      }

      if (['packages', 'package-modal'].includes(routeName) && rootGetters.config) {
        return {
          description: rootGetters.config.liveHerePackagesSidebarDesc[rootState.language.code] || rootGetters.config.liveHerePackagesSidebarDesc['en'],
          filterType: 'package',
          heading: rootGetters.config.liveHerePackagesSidebarHeading[rootState.language.code] || rootGetters.config.liveHerePackagesSidebarHeading['en'],
          markerGuide: false,
          minimapImage: '',
          qrMessage: '',
          qrUrl: '',
        }
      }

      if (['dwellings', 'dwelling-modal'].includes(routeName) && rootGetters.config) {
        return {
          description: rootGetters.config.liveHerePackagesSidebarDesc[rootState.language.code] || rootGetters.config.liveHerePackagesSidebarDesc['en'],
          filterType: 'dwelling',
          heading: rootGetters.config.liveHerePackagesSidebarHeading[rootState.language.code] || rootGetters.config.liveHerePackagesSidebarHeading['en'],
          markerGuide: false,
          minimapImage: '',
          qrMessage: '',
          qrUrl: '',
        }
      }

      if (['favourites', 'favourite-modal'].includes(routeName) && rootGetters.config) {
        return {
          description: rootGetters.config.liveHereFavouritesSidebarDesc[rootState.language.code] || rootGetters.config.liveHereFavouritesSidebarDesc['en'],
          filterType: '',
          heading: rootGetters.config.liveHereFavouritesSidebarHeading[rootState.language.code] || rootGetters.config.liveHereFavouritesSidebarHeading['en'],
          markerGuide: false,
          minimapImage: '',
          qrMessage: '',
          qrUrl: rootGetters['favourites/qrcode'],
        }
      }

      return {}
    },
    
    isSlideOutVisible (state) {
      return state.isSlideOutVisible
    },

    shouldSlideOutAutoOpen (state) {
      return !state.hasUserClosedSlideOut && !state.isSlideOutVisible
    }
  }
}
